import { Crown, Rocket, Building, Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/authContext";

interface PlanBadgeProps {
  plan: string;
}

const ADMIN_EMAIL = "enricarloni@gmail.com";

export default function PlanBadge({ plan }: PlanBadgeProps) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.email?.toLowerCase() === ADMIN_EMAIL;

  // Admin users get a dedicated green Admin button in place of the plan badge.
  if (isAdmin) {
    return (
      <button
        type="button"
        onClick={() => navigate("/admin")}
        aria-label="Open admin dashboard"
        className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-full text-white shadow-sm hover:opacity-90 transition-opacity"
        style={{ backgroundColor: "#2d8653" }}
      >
        <Shield className="w-3.5 h-3.5" />
        Admin
      </button>
    );
  }

  if (plan === "pro") {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-full bg-primary/10 text-primary">
        <Crown className="w-3 h-3" /> Pro
      </span>
    );
  }

  if (plan === "business") {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-full bg-purple-500/10 text-purple-600">
        <Building className="w-3 h-3" /> Studio
      </span>
    );
  }

  if (plan === "enterprise") {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-full bg-amber-500/10 text-amber-600">
        <Rocket className="w-3 h-3" /> Enterprise
      </span>
    );
  }

  return (
    <span className="text-xs font-medium px-2 py-1 rounded-full bg-muted text-muted-foreground">
      Free
    </span>
  );
}
